var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.666,
    cy: 64,
    r: 56,
    fill: "#FEF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.666 32L114.666 32",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 82L17.666 82",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.666 39L112.666 39",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66602 89L15.666 89",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 32H125.666",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6661 88C89.9209 88 100.666 77.2548 100.666 64C100.666 50.7452 89.9209 40 76.6661 40C63.4112 40 52.666 50.7452 52.666 64C52.666 77.2548 63.4112 88 76.6661 88Z",
    stroke: "#E9688A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6661 80C85.5026 80 92.666 72.8366 92.666 64C92.666 55.1634 85.5026 48 76.6661 48C67.8295 48 60.666 55.1634 60.666 64C60.666 72.8366 67.8295 80 76.6661 80Z",
    stroke: "#E9688A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.666 70C79.9797 70 82.666 67.3137 82.666 64C82.666 60.6863 79.9797 58 76.666 58C73.3523 58 70.666 60.6863 70.666 64C70.666 67.3137 73.3523 70 76.666 70Z",
    fill: "#E9688A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6729 53.334L76.6189 64.4735",
    stroke: "#E9688A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0751 56.4327L40.7484 63.0399L28.666 59.8253L34.7962 53.1272L32.1476 44.7422L44.23 47.9568L48.0751 56.4327Z",
    stroke: "#E9688A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.492bcc436158ec2a8bdeaf9cf883f1fa.svg";
export { ForwardRef as ReactComponent };